import { Button, Checkbox, Popover } from "antd";
import {
  ArrowLeftOutlined,
  FolderFilled,
  PlayCircleFilled,
} from "@ant-design/icons";
import { ReactComponent as HelpIcon } from "../../../assets/images/Help.svg";
import CollarUnselected from "../../../assets/images/herd/collar-unselected.png";
import "./HerdsToDisplay.scss";
import PopoverTitle from "../../common/PopoverTitle";
import clsx from "clsx";

function HerdsToDisplay(props) {
  const {
    onBackButtonClick,
    herdStep9Popover,
    setCurrentStep,
    currentStepDetails,
    herdStep10Popover,
    herdMarkerDetails,
  } = props;

  const contentOfHerdStep9Popover = (
    <div>
      <p>Your herd will also appear in your herds list on the right.</p>
      <div>
        <Button
          type="primary"
          size="middle"
          style={{ left: "80%" }}
          onClick={() => setCurrentStep((step) => step + 1)}
          className="tutorial-guide-button"
        >
          Next
        </Button>
      </div>
    </div>
  );

  const contentOfHerdStep10Popover = (
    <div>
      <p>
        To see the individual animals in your herd, click the Vence collar icon
        to get the last known location of the collars in this herd.
      </p>
    </div>
  );
  return (
    <div>
      <Button
        block
        className="back-button"
        // onClick={() => onBackButtonClick()}
        icon={<ArrowLeftOutlined />}
      >
        BACK
      </Button>
      <div className="herds-to-display">
        <div className="header">
          <label className="title">Select Herds to Display</label>
          <Button
            type="text"
            style={{ marginLeft: "auto" }}
            icon={<HelpIcon className="help-icon" />}
          />
        </div>
        <div className="herds-to-display-body">
          <Button block className="sub-item">
            Select All Herds {/* Clear All Herds */}
          </Button>
          <Button block className="sub-item">
            Select All Collars {/* Clear All Collars */}
          </Button>
          <div className="herds-list">
            <div className="herd-folder">
              <FolderFilled className="folder-icon" />
              <Checkbox style={{ marginLeft: "5px" }}>Archive</Checkbox>
            </div>
            <Popover
              title={PopoverTitle}
              content={contentOfHerdStep9Popover}
              placement="leftTop"
              trigger="hover"
              visible={herdStep9Popover}
            >
              <div
                id="herd-item"
                className={clsx("herd-item", {
                  "overlay-element-active":
                    currentStepDetails.overlayElementsId?.includes("herd-item"),
                })}
              >
                <Checkbox defaultChecked={true}>
                  <div className="herd-count">
                    {herdMarkerDetails.coordinates?.length || 10}
                  </div>
                  <div className="herd-name">
                    {herdMarkerDetails.herdName || "Test Herd"}
                  </div>
                </Checkbox>
                <Popover
                  title={PopoverTitle}
                  content={contentOfHerdStep10Popover}
                  placement="leftTop"
                  trigger="hover"
                  visible={herdStep10Popover}
                >
                  <div
                    id="collar-img"
                    className={clsx({
                      "overlay-element-active":
                        currentStepDetails.overlayElementsId?.includes(
                          "collar-img"
                        ),
                    })}
                    style={{
                      backgroundColor: "whitesmoke",
                      padding: "5px",
                      cursor: "pointer",
                    }}
                    onClick={() => setCurrentStep((step) => step + 1)}
                  >
                    <img
                      src={CollarUnselected}
                      alt="Collar"
                      style={{
                        width: "20px",
                        height: "12px",
                        marginLeft: "auto",
                      }}
                    />
                  </div>
                </Popover>
                <PlayCircleFilled
                  style={{ fontSize: "12px", marginLeft: "5px" }}
                />
              </div>
            </Popover>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HerdsToDisplay;
